import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import UltimateIcon from '@/components/ultimate-icon/UltimateIcon.vue'

Vue.component(FeatherIcon.name, FeatherIcon)

Vue.component('UltimateIcon', UltimateIcon)
